import { css } from '@inter-ikea-kompis/web-component';
export default class ProductShelfStyle {
    static getStyle(options) {
        const { space50, space100 } = options.theme.spacing;
        return css `
			kompis-carousel-item {
				justify-content: flex-start;
				flex-direction: column;
				min-width: ${249 / 16}rem;
				max-width: ${249 / 16}rem;
				padding: ${space100 / 16}rem;
			}

			.container {
				display: flex;
				flex-direction: column;
			}

			kompis-add-to-bag {
				align-self: flex-end;
				margin-top: ${space50 / 16}rem;
			}

			kompis-product-card {
				width: 100%;
			}
		`;
    }
}
//# sourceMappingURL=ProductShelfStyle.js.map